
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gcUEM8eBgbO_45onbdX4mjsOqpD7Kwav9mjbhOnuVTmiSQMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexq7APzWrgCz8AL93s13KfU521eSu_45ExAtI9jejno8eDgMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchw709ErnNzeaD9yc3ar0nrXzNfWkI6A0H1_dTDwDubCQMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index_45nQfi8zybbH_45BU4NlzpkCzDmKWEezEcVw_egUy7IZd4Meta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93crkKbRG1Tm0aeM4XKfhjA3qusJCO_OlW9QPlRPFh81sMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexgcEEQ5ePZuLaENuhjvhowY_45P3VxdUP9pUMgxJ3Vqlx4Meta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93uubz2zpUaQI_gL9UEKl1Ak3A0O7vqOJRENLgZMazUtIMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexm_nPYldWIEc10CHQynDea0xyhxN_45mrpNgUxi_455J55HAMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93PptrVExLwS_45wl4WMfuSC77oOrFmPcDtpmay06dd8O5IMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexpWggHcn1KbCMc6b1DTc04cknQHRUj5G0J0C7BSx_45olQMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index5gGKDBl0Q8PyiEqagBdp3bXjmoGvhSzZJwUUUM9pMFUMeta } from "/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexgcEEQ5ePZuLaENuhjvhowY_45P3VxdUP9pUMgxJ3Vqlx4Meta || {},
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexm_nPYldWIEc10CHQynDea0xyhxN_45mrpNgUxi_455J55HAMeta || {},
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexpWggHcn1KbCMc6b1DTc04cknQHRUj5G0J0C7BSx_45olQMeta || {},
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index5gGKDBl0Q8PyiEqagBdp3bXjmoGvhSzZJwUUUM9pMFUMeta || {},
    component: () => import("/codebuild/output/src118944342/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]